import trackProductEvent from '../../../utils/trackProductEvent';

// eslint-disable-next-line no-restricted-syntax
export default function trackClickIntoPDP(sku, subSource) {
  const eventName = 'ungated_shopping_bag_clicked_into_pdp';
  const canonicalName = 'shopping_bag';
  const actionType = 'click';
  const actionName = 'clicked_into_pdp';
  const actionDetail = 'ungated_shop';
  const directBuyContext = {
    skus: [{ sku_id: sku.id, source: 'ungated_shop', sub_source: subSource }],
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
}
